import { useQuery } from 'react-query';
import { washHub } from 'store/slices';
import { fetchAllCounts } from 'api/inventory';

export const useInventoryCounts = ({
  page,
  status,
  endDate,
  startDate,
  site,
  limit = 10,
}: {
  page?: number;
  limit?: number;
  endDate?: Date;
  startDate?: Date;
  status?: number;
  site?: string[];
} = {}) => {
  const washHubId = washHub.selectors.useSelectedWashHubId();
  const isWashHubIdValid = washHub.selectors.useIsWashHubIdValid();
  const queryKey = [
    'fetch-inventory-counts',
    page,
    status ?? undefined,
    washHubId,
    endDate,
    startDate,
    site?.toString(),
  ];

  const queryFn = () =>
    fetchAllCounts({
      ...(status !== undefined ? { status } : {}),
      page,
      limit,
      sort: -1,
      washHub: washHubId,
      endDate,
      startDate,
      site,
    });
  const options = {
    enabled: isWashHubIdValid, //!!washHubId
    keepPreviousData: true,
  };

  const { data, isFetching } = useQuery(queryKey, queryFn, options);
  const counts = data?.items || [];
  const total = data?.total || 0;
  const currentPage = data?.currentPage || 0;
  const totalPages = data?.totalPages || 0;
  return { counts, total, currentPage, totalPages, isFetching };
};
